import React from "react";
import { Container } from "react-bootstrap";
import NavBar from "./navbar";
import Table from "react-bootstrap/Table";
import Footer from "./footer";

function Resume() {
  return (
    <div>
      <NavBar />
      <section className="page-content">
        <Container>
          <div className="resume-content" style={{ marginLeft: "10%", marginRight: "10%" }}>
            <h1>
              <b>Resume</b>
            </h1>
            <p align="justify">
              Hi, there 👋 I am Aryan. Here's a <a href="https://drive.google.com/file/d/17ZrhEEfDxy_M7VVrfBJlIwSZI0460nMS/view?usp=sharing">link</a> to the PDF version of my Curriculum Vitae.
            </p>
            {/* <p>
              <h3>
                <p>
                  <b>Areas of Expertise</b>
                  <h5><b>Languages</b></h5>
                  Python
                </p>
              </h3>
              <hr></hr>
            </p> */}

            <br/>
            <div className="Education">
              <p align="left">
                <h3>
                  <b>Education</b>
                </h3>
                <hr></hr>
                <p>
                  <h5>
                    <b>
                      International Institute of Information Technology Pune
                    </b>
                  </h5>
                  {/* <br /> */}
                  August 2019 - June 2023
                  <br />
                  Bachelor's in Engineering – Computer Engineering
                  <br />
                  CGPA: 8.8/10
                </p>

                <h5>
                  <b>St. Vincent's High School</b>
                </h5>
                <p>
                  June 2011 - March 2017 High School Degree
                  <br />
                  SSC: 91.2%
                </p>
              </p>
            </div>

            <br/>
            <div className="Courses">
              <p align="left">
                <h3>
                  <b>Courses</b>
                </h3>
                <hr></hr>
                <ul>
                  <li>Data Structures and Algorithms</li>
                  <li>Computer Networks and Security</li>
                  <li>Discrete Mathematics</li>
                  <li>Database Management Systems</li>
                </ul>
              </p>
            </div>

            <br/>
            <div className="HnA">
              <p align="left">
                <h3>
                  <b>Honors and Awards</b>
                </h3>
                <hr></hr>
                <h5>Hyundai Social Creator</h5>
                <p align="justify">
                 <em> Issued by Hyundai Motors India · Nov 2019</em>
                  <br />
                  Selected among the TOP 10 finalists at the Nationwide
                  conducted innovation challenge competition organized by
                  Hyundai Motors. Represented the Smart Waste Segregation Project
                  under the guidance of an experienced mentor from IIT Kharagpur.
                </p>
                
                <h5>Barclays Tech Innovation Challenge</h5>
                <p align="justify">
                  <em>Issued by Barclays India · Sep 2019</em>
                  <br />
                  Presented a group project on the segregation of garbage into
                  dry and wet categories and an idea of the working prototype
                  through Gas Detecting Sensors in a Hackathon organized by
                  BARCLAYS. Competed against more than 30 teams from 19
                  different colleges and secured 1st Place
                </p>
              </p>
            </div>
          </div>
        </Container>
      </section>
      <Footer />
    </div>
  );
}

export default Resume;
